module.exports = __webpack_public_path__ + "img/music-player-details4.7dd3a3e6.png";